import { useEffect, useState } from 'react';
import type { WfProps } from './element';

function formatNumber(num: number): string {
  if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
}

/** Total GitHub stars across the dbos-inc organization's public repos, fetched in the browser. */
export function GithubStars({ as: Tag = 'div', ...props }: WfProps) {
  const [stars, setStars] = useState('...');
  useEffect(() => {
    let cancelled = false;
    fetch('https://api.github.com/users/dbos-inc/repos?per_page=100')
      .then((r) => r.json())
      .then((repos: unknown) => {
        if (!Array.isArray(repos)) throw new Error('Unexpected GitHub API response');
        const total = repos.reduce((sum: number, repo: { stargazers_count: number }) => sum + repo.stargazers_count, 0);
        if (!cancelled) setStars(formatNumber(total));
      })
      .catch((err: unknown) => {
        console.error('Error fetching GitHub stars:', err);
        if (!cancelled) setStars('—');
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return <Tag {...props}>{stars}</Tag>;
}
